module.exports = __webpack_public_path__ + "static/media/icon-search-1.6ddb6cd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/icon-search-1.svg
// module id = 1695
// module chunks = 0